import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Button } from "react-bootstrap";
import {  Divider } from "@mui/material";

const BookNowDoctor = () => {
  
  return (
    <>
      <Header />
      <Sidebar
        // id="menu-item"
        // id1="menu-items"
        // activeClassName="card-patientdashboard"
      />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">See Doctor Now </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    Book Appointment Now
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body ">
     
              <div className=" text-center mb-3">
                <h4>Book Now</h4>
              </div>
             <Divider sx={{backgroundColor:"#2e37a4",marginBottom:"10px"}} />
              <div>
              <p className="h5 text-center mb-3">
                If you want to meet the Doctor instantly, just get through these
                easy steps and book an appointment. Enter into the waiting room
                and get consultation.
              </p>
              </div>
              <div >
                <Link to="/booknowform">
                <Button  className="btn-lg btn-block mb-3">See Doctor Now</Button>

                </Link>
                
                
                {/* <Button className=" btn-block mb-3" variant="contained" sx={{backgroundColor:"#2e37a4"}}>See Now Doctor</Button> */}
              </div>
             
              <div>
              <p className="h5 text-center mb-5"> 
                If this is an emergency please hang up and dial 911 other wise
                you can create a request for call
              </p>
              </div>
           
              
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNowDoctor;
